import { useQuery } from "@tanstack/react-query";

import { getSchemeSummary } from "@services/subscriber";

// The scheme selected in the app bar (the API reads it from the request).
export const useSchemeSummary = (options?: Record<string, any>) => {
  return useQuery<any>({
    queryKey: ["schemeSummary"],
    queryFn: () => getSchemeSummary(),
    ...options,
  });
};
